import { isEmpty } from 'ramda'

import { ReportsDataOrderPurchasesResult, dateFormat } from 'app/common/api/requests/reports/data.orders_purchases'
import SimpleDate from 'app/common/classes/simple-date'

import toFixedValue from 'app/common/lib/toFixedValue'


export type PurchaseItem = {
  id: number,
  title: string,
  cost: string,
  count: string,
  total: string,
}

export type OrdersPurchases = {
  from: SimpleDate | null
  to: SimpleDate | null
  purchases: Array<PurchaseItem>
  groups: {
    names: Array<string>
    classes: Array<string>
    countsByClass: Record<string, Array<number>>
    totals: Array<number>
  }
}

export const ordersPurchasesConvert = (data: ReportsDataOrderPurchasesResult): OrdersPurchases => {
  const { purchases = [], groups = {}, from, to } = data

  return {
    from: from ? new SimpleDate(from, dateFormat) : null,
    to: to ? new SimpleDate(to, dateFormat) : null,
    purchases: purchases.map(({ id, title, cost, count, total }) => ({
      id,
      title: title || '???',
      cost: toFixedValue(cost),
      count: typeof count === 'number' ? String(count) : '—',
      total: toFixedValue(total),
    })),
    groups: (() => {
      const classes = Object.keys(groups)

      if (isEmpty(classes)) {
        return { names: [], classes: [], countsByClass: {}, totals: [] }
      }

      const names = groups[classes[0]].map(({ title }) => title)
      const totals = Array.from({ length: names.length }, () => 0)
      const countsByClass = classes.reduce((acc, val) => {
        acc[val] = groups[val].map(({ count }, index) => {
          totals[index] += count
          return count
        })
        return acc
      }, {} as Record<string, Array<number>>)

      return {
        names,
        classes,
        countsByClass,
        totals,
      }
    })(),
  }
}
